import TagService from '@bo/services/tagService';
import { useCallback, useEffect, useRef, useState } from 'react';

const tagService = new TagService();

const useTags = ({ search, page, perPage }) => {
    const [tags, setTags] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const abortRef = useRef(null);

    const fetchTags = useCallback(async () => {
        if (abortRef.current) abortRef.current.abort();
        abortRef.current = new AbortController();

        setLoading(true);
        try {
            const data = await tagService.getTagsPaginated({ search, page, perPage });
            setTags(data.items ?? []);
            setTotal(data.total ?? 0);
            setError(null);
        } catch (err) {
            if (err.name !== 'AbortError') setError(err);
        } finally {
            setLoading(false);
        }
    }, [search, page, perPage]);

    useEffect(() => {
        fetchTags();
        return () => abortRef.current?.abort();
    }, [fetchTags]);

    return { tags, total, loading, error, refresh: fetchTags };
};

export default useTags;
